// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { DepositFragment } from '../../fragments/generated/deposit.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetNotIncludedDepositsQueryVariables = Types.Exact<{
  getNotIncludedDepositsRequestDTO: Types.GetNotIncludedDepositsRequestDtoInput;
}>;


export type GetNotIncludedDepositsQueryResult = { __typename?: 'Query', getNotIncludedDeposits: Array<{ __typename?: 'DepositDTO', amount: number, block: string | null, date: LocalDate, depositInvoiceId: number | null, depositUseId: number | null, holderId: number | null, holderType: Types.InvoiceHolderTypeDto | null, id: number, ownerCorporateDataId: number | null, ownerId: number, paymentId: number | null, reservationId: number | null, username: string | null }> };

export const GetNotIncludedDepositsGql = gql`
    query GetNotIncludedDeposits($getNotIncludedDepositsRequestDTO: GetNotIncludedDepositsRequestDTOInput!) {
  getNotIncludedDeposits(
    getNotIncludedDepositsRequestDTO: $getNotIncludedDepositsRequestDTO
  ) {
    ...Deposit
  }
}
    ${DepositFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotIncludedDepositsInjectable extends Apollo.Query<GetNotIncludedDepositsQueryResult, GetNotIncludedDepositsQueryVariables> {
    override document = GetNotIncludedDepositsGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */